<template>
    <main class="layout layout--registration">
        <l-r-header></l-r-header>
        <router-view>
        </router-view>
        <l-footer :theme="'white'"></l-footer>
    </main>
</template>

<script>
import lRHeader from "@/views/registration/header-registration";
import lHeader from "@/views/header";
import lFooter from "@/views/footer";

export default {
  name: "Layout",
  components: {
    lHeader,
    lRHeader,
    lFooter
  }
};
</script>

<style lang="scss">
.fade-enter-active {
    transition: opacity .5s;
}
.fade-enter{
    opacity: 0;
}
.fade-leave-active{
    display: none;
}
.fade-leave-to{
    display: none;
}
.layout{
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    .content--registration {
        display: flex;
    }
    .content{
        flex: 1;
    }
    &.layout--registration{
        background: #f6f6f6;
    }
}
@media screen and (max-width: 1024px) {
    .content{
        padding-top: 48px;
    }
    .content--registration{
        padding-top: 68px;
    }
    .layout{

    }
}

</style>
